module.exports = {
  siteTitle: 'DataTech Inc', // Site title.
  siteTitleAlt: 'Software consulting', // Alternative site title for SEO.
  siteLogo: '/icons/Datatech_logo.png', // Logo used for SEO and manifest.
  siteUrl: 'https://netlify-gatsby-datatechinc.netlify.com', // Domain of your website without pathPrefix.
  pathPrefix: '', // Prefixes all links. For cases when deployed to example.github.io/gatsby-starter-business/.
  siteDescription: 'Software services and consulting provider', // Website description used for RSS feeds/meta description tag.
  siteRss: '/rss.xml',
  siteFBAppID: '', // FB Application ID for using app insights
  googleTagManagerID: '', // GTM tracking ID.
  disqusShortname: 'datatechinc-ca', // Disqus shortname.
  userName: 'Datatecinc',
  userTwitter: 'vaibhDatatecincaved',
  userLocation: 'Toronto',
  userDescription: '',
  copyright: 'Copyright © datatech inc 2026. All Rights Reserved.', // Copyright string for the footer of the website and RSS feed.
  themeColor: '#00d1b2', // Used for setting manifest and progress theme colors.
  backgroundColor: '#ffffff', // Used for setting manifest background color.
}
